import * as React from 'react';
import FAIcon from '../fAIcon/FAIcon';
import {
    IDataForTheStatistic,
    IStatisticBoxBookingObject,
    IStatisticBoxCourseObject,
    IStatisticBoxParticipantObject
} from '../fieldsetBox/FieldsetBox';
import './FieldsetBoxWithCollapseButton.css';

interface IState {
    showMore: boolean;
}

export interface IFieldsetBoxWithCollapseButtonProps<T> {
    children?: React.ReactNode;
    fieldsetClass?: string;
    legendTitel: string;
    firstNumber: number;
    listData: T[];
    renderTBodyLine: (value: T, index: number) => void;
    renderTHeadLine?: JSX.Element;
    tableClass?: string;
}

export default class FieldsetBoxWithCollapseButton extends React.PureComponent<
    IFieldsetBoxWithCollapseButtonProps<any>,
    IState
> {
    constructor(
        props: IFieldsetBoxWithCollapseButtonProps<
            | IStatisticBoxCourseObject
            | IStatisticBoxParticipantObject
            | IDataForTheStatistic
            | IStatisticBoxBookingObject
        >
    ) {
        super(props);
        this.state = {
            showMore: false
        };
    }

    public render() {
        const fieldsetclasses: string[] = ['FieldsetBox'];
        const tableclasses: string[] = ['FieldsetBoxTable', 'collapsible'];
        if (this.props.fieldsetClass) {
            fieldsetclasses.push(this.props.fieldsetClass);
        }

        if (this.props.tableClass) {
            tableclasses.push(this.props.tableClass);
        }

        return (
            <div>
                <fieldset className={fieldsetclasses.join(' ')}>
                    <legend>
                        <b>{this.props.legendTitel}</b>
                    </legend>
                    {this.props.listData && (
                        <table className={tableclasses.join(' ')}>
                            {this.props.renderTHeadLine !== undefined ? this.props.renderTHeadLine : null}
                            <tbody>
                                {!this.state.showMore &&
                                    this.props.listData
                                        .slice(0, this.props.firstNumber)
                                        .map(this.props.renderTBodyLine)}
                                {this.state.showMore && this.props.listData.map(this.props.renderTBodyLine)}
                            </tbody>
                        </table>
                    )}
                    {this.props.listData && this.props.listData.length > this.props.firstNumber && (
                        <div className="text-right addMoreRecords">
                            <a onClick={this.showMoreData}>
                                {this.state.showMore && <FAIcon mouseHover="Weniger anzeigen" icon="minus-circle" />}
                                {!this.state.showMore && <FAIcon mouseHover="Mehr anzeigen" icon="plus-circle" />}
                            </a>
                            <a onClick={this.showMoreData}>
                                <span>
                                    &nbsp;
                                    {this.state.showMore ? 'Weniger anzeigen' : 'Mehr anzeigen'}
                                </span>
                            </a>
                        </div>
                    )}
                </fieldset>
            </div>
        );
    }

    private showMoreData = () => {
        this.setState({ showMore: !this.state.showMore });
    };
}



// WEBPACK FOOTER //
// ./src/components/fieldsetBoxWithCollapseButton/FieldsetBoxWithCollapseButton.tsx